"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runtime = require("../runtime");
var _default = exports.default = (0, _runtime.IconWrapper)('symbol_cross_two', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("style", ['.kd-stroke-width-icon-regular{stroke-width:var(--kd-stroke-width-icon-regular, 1px); }.kd-color-icon-primary{fill:#333333; fill:var(--kd-color-icon-primary, #333333); stroke:#333333; stroke:var(--kd-color-icon-primary, #333333); }']), h("g", {
    "class": "kd-color-icon-primary kd-stroke-width-icon-regular"
  }, [h("path", {
    "attrs": {
      "d": "M3.5 3.5L12.5 12.5",
      "stroke-linecap": "round",
      "fill": "none",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    }
  }), h("path", {
    "attrs": {
      "d": "M3.5 12.5L12.5 3.5",
      "stroke-linecap": "round",
      "fill": "none",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    }
  })])]);
});